import React from "react";
import compose from "lodash/flowRight";
import {graphql, withApollo} from "@apollo/client/react/hoc";
import {connect} from "react-redux";
import withAuth from "shared/Auth/withAuth/withAuth";
import GetUniversityQuery from "shared/University/queries/GetUniversityQuery";
import withIdentify from "shared/Auth/withIdentify";
import s from "./MentorCardWidget.pcss";
import MentorCardWidgetRoutes from "./MentorCardWidgetRoutes";

const MentorCardWidget = (props) => (
    <div className={s.container}>
        <MentorCardWidgetRoutes {...props} />
    </div>
);

const universityQueryOptions = {
    name: "universityQuery",
    // options for the initial query
    options(props) {
        return {
            variables: {
                slug: props.match.params.universitySlug,
            },
            fetchPolicy: "cache-and-network",
        };
    },
    // convert the ugly apollo results into custom props
    props({universityQuery: {university}}) {
        return {
            university,
        };
    },
};

export default compose(
    connect(),
    withApollo,
    withAuth,
    withIdentify,
    graphql(GetUniversityQuery, universityQueryOptions),
)(MentorCardWidget);
